import styles from './styles.module.scss';
const steps = [
 ['Выберите курс', 'Программа, формат и темп — в каталоге выше.'],
 ['Оставьте заявку', 'Имя и телефон. Курс и цена уже будут в форме.'],
 ['Обсудите начало', 'Свяжемся, ответим на вопросы и уточним группу и дату старта.']
];
export const Process = () => <section className={styles.process} id="process" aria-labelledby="start-title"><div className={styles.inner}>
 <div className={styles.heading}><h2 id="start-title">Как записаться</h2></div>
 <ol className={styles.steps}>{steps.map(([title,text], index) => <li key={title}><span className={styles.number} aria-hidden="true">{index+1}</span><div><h3>{title}</h3><p>{text}</p></div></li>)}</ol>
</div></section>;
